<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Ticket History</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Billing History</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Billing History</h3>
                <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
                    class="fa fa-filter"></i>Filter</a>
                <!-- <div class="card-tools">
                   <button class="btn btn-info" @click="exportFile()">
                      <i class="fas fa-download"></i> Export
                    </button> 
                </div> -->
              </div>
              <form @submit.prevent="getList" method="GET" novalidate>
                <div class="card-body" v-if="showFilter">
                  <div class="form-row">
                    <div class="col-md-12">
                      <!-- Period -->
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="invoice_at">Period</label>
                        <div class="col-md-9">
                          <date-picker type="datetime" input-class="form-control" v-model="filter.invoice_at" range
                            lang="en" format="YYYY-MM-DD HH:mm:ss" confirm id="invoice_at"
                            value-type="YYYY-MM-DD HH:mm:ss"></date-picker>
                        </div>
                      </div>

                      <!-- Status  -->
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="status">Status</label>
                        <div class="col-md-9">
                          <multiselect v-model="filter.status" :options="['Paid', 'Unpaid']" placeholder="Select"
                            :searchable="true" :multiple="false" v-validate="'required'" id="status" name="status">
                          </multiselect>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-9 offset-md-3">
                          <button type="submit" class="btn btn-common m-2px">
                            <i class="fas fa-search"></i> Search
                          </button>
                          <button type="reset" class="btn btn-warning" @click="resetFilter()">
                            <i class="fas fa-undo"></i> Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table common-table">
                    <thead>
                      <!-- Vendor	Subscriber	Order Reference No	Fullfilment Request No	Access CASR	Order State	Activated On	Remarks	Notes	Action -->
                      <tr>
                        <!-- <th class="">ID</th> -->
                        <th class="">Billing Month</th>
                        <th class="text-right">Bill Amount</th>
                        <th class="text-center">Bill Status</th>
                        <th class="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody class="users-list">
                      <tr v-for="(val, index) in list" :key="val.id">

                        <!-- service_name -->
                        <td>
                          {{ getFormattedDate(val.invoice_at) }}
                        </td>
                        <td class="text-right">
                          {{ formatNumber(val.amount) }}
                        </td>
                        <!-- {{ customFormatter(val.created_at) }} -->

                        <td class="text-center">
                          <span :class="[val.status ? val.status.toLowerCase() : '']">
                            {{

                              val.status

                            }}
                          </span>

                        </td>

                        <td>
                          <button class="btn" @click.prevent="showDetails(val.id)"><i class="far fa-file mr-1"></i>
                            Details</button>
                          <button class="btn" @click.prevent="downloadInvoice(val.id)"><i
                              class="far fa-file-pdf mr-1"></i> PDF</button>
                        </td>


                        <!-- <td class="text-right"></td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="p-4" v-if="_.isEmpty(list) && !list.is_loading">
                  <div class="alert alert-default-warning" role="alert">
                    No data found!
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <vue-pagination :pagination="list" v-if="list.total > list.per_page" @paginate="getList()" />
              </div>
            </div>
          </div>
          <div class="col-md-4" v-show="!isUnpaidEmpty">
            <div class="payment-due">
              <h3>Payments due</h3>
              <ul>
                <li>My package <span>{{ packageInfo.package }}</span></li>
                <li>Bill due date <span> {{ packageInfo.billDueDate }} </span></li>
                <!-- 11/02/2025 -->
                <li>Monthly bill <span>£ {{ packageInfo.monthlyAmount }} </span></li>
                <!-- monthlyAmount -->
                <li>Available balance <span>£ {{ packageInfo.availableBalance }}</span></li>
                <li>Total bill <span>£ {{ packageInfo.monthlyAmount }}</span></li>
              </ul>

              <button class="btn" data-toggle="modal" data-target="#paymentStatus" :disabled="isUnpaidEmpty"
                @click="handlePayNow">
                Pay now
              </button>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>

    <div class="modal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="detailModalLabel">Billing Details</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Billing Month</th>
                  <th scope="col">Particulars</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Invoice at</th>
                  <th scope="col">Bill status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, i) in details">
                  <td scope="col">{{ getFormattedDate(v.invoice_at) }}</td>
                  <td scope="col">{{ v.service_name }}</td>
                  <td scope="col">{{ formatNumber(v.service_charge) }}</td>
                  <td scope="col">{{ v.invoice_at }}</td>
                  <td scope="col">{{ v.status }}</td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Send message</button> -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="paymentStatus" tabindex="-1" role="dialog" aria-labelledby="paymentStatusLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="/assets/images/icon-modal-close.svg" alt="">
          </button>
          <div class="payment-status">
            <div v-if="paymentStatus === 'success'" class="payment-success">
              <img src="/assets/images/payment-success.svg" alt="payment status" />
              <h3>Payment success</h3>
              <p><span>Your payment has been successfully completed.</span></p>
              <p>Please check your email for your payment confirmation and further information.</p>
            </div>
            <div v-else-if="paymentStatus === 'failed'" class="payment-failed">
              <img src="/assets/images/payment-failure.svg" alt="payment status" />
              <h3>Payment Failure</h3>
              <p><span>Oops! It looks like there was an issue with your payment, and we couldn’t complete your
                  order.</span></p>
              <p>Please double-check your payment details and try again. If you need any help, just let us know.</p>
              <div class="payment-failed-cta">
                <a :href="contactUrl" class="btn">Contact us</a>
                <a href="javascript:void(0);" class="btn" @click="retryPayment" :disabled="isProcessing">Try again</a>
              </div>
            </div>
            <div v-else-if="paymentStatus === 'processing'" class="payment-processing">
              <img src="/assets/images/payment-processing.svg" alt="payment status" />
              <h3>Payment Processing</h3>
              <p><span>The payment will take a little time to go through</span></p>
              <p>We’ll drop you an email as soon as it’s all sorted.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
.closed,
.pending,
.open,
.in-progress {
  border-radius: 100px;
  text-align: center;
  padding: 4px 10px 4px;
  display: inline-block;
  font-size: 13px;
}

span.closed {
  color: #16a085;
  background-color: #e1f9f4;
  border-color: #e1f9f4;
}

span.pending {
  color: #f1711d;
  background-color: #ffe9dd;
  border-color: #ffe9dd;
}

span.open {
  color: #2980b9;
  background-color: #e4f4ff;
  border-color: #e4f4ff;
}

span.in-progress {
  color: #efb548;
  background-color: #fbeacb;
  border-color: #fbeacb;
}

button.btn_new {
  padding: 0 5px 0 5px;
  border-style: none;
}

.table>tbody>tr>td:last-child .btn {
  width: auto;
  padding: 8px 18px 8px;
  line-height: 1;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI, SelfcareAPI } from "@/services/api";

const fileDownload = require("js-file-download");
import { Notification } from "element-ui";
import { round, thru } from "lodash";

export default {
  name: "BillingHistory",
  metaInfo: {
    title: "Billing History",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    details: [],
    paymentStatus: null,
    unpaidInvoice: {

    },
    isProcessing: false,
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
    contactUrl: process.env.VUE_APP_CONTACT_URL || '',
  }),

  computed: {
    ...mapGetters(["packageInfo", "accountInfo"]),
    isUnpaidEmpty() {
      return !this.unpaidInvoice || Object.keys(this.unpaidInvoice).length === 0;
    }
  },

  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }

      // window.$(document).find('.push-menu-class').trigger('click');
    }

    this.companyName = process.env.VUE_APP_COMPANY_NAME || '';

    this.getPackageInfo();
    // this.api_url = "/ticketList";
    this.getList();
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getList();
    });
  },


  metaInfo() {
    return {
      title: this.companyName
        ? `Billing History | ${this.companyName}`
        : "Billing History",
    };
  },
  methods: {

    // FETCH_PACKAGE_INFO
    ...mapActions(["FETCH_PACKAGE_INFO", "FETCH_ACCOUNT_INFO"]),

    getPackageInfo: function () {
      this.FETCH_PACKAGE_INFO(); //FETCH_PACKAGE_INFO
    },

    getAccountInfo: function () {
      this.FETCH_ACCOUNT_INFO();
    },

    async retryPayment() {
      let _this = this;
      if (!this.unpaidInvoice || Object.keys(this.unpaidInvoice).length === 0) {
        console.warn("No unpaid invoice found — payment not possible.");
        return;
      }
      console.log("Found an unpaid invoice!");

      _this.isProcessing = true;

      let payload = {
        'invoice_id': _this.unpaidInvoice.id,
        'account_id': _this.unpaidInvoice.account_id,
        'try_again': 1
      };

      _this.paymentStatus = 'processing';

      SelfcareAPI.takeInvoicePayment(payload)
        .then((response) => {
          if (response.status === true) {
            _this.paymentStatus = 'success';
          } else {
            _this.paymentStatus = 'failed';
          }
        }).catch((error) => {
          _this.paymentStatus = 'failed';
        }).finally(() => {
          // this block always execute
          // _this.paymentStatus = null;
          _this.isProcessing = false;
        });
    },

    async handlePayNow() {
      let _this = this;
      if (!this.unpaidInvoice || Object.keys(this.unpaidInvoice).length === 0) {
        console.warn("No unpaid invoice found — payment not possible.");
        return;
      }
      console.log("Found an unpaid invoice!");


      let payload = {
        'invoice_id': _this.unpaidInvoice.id,
        'account_id': _this.unpaidInvoice.account_id,
        'try_again': 0
      };

      _this.paymentStatus = 'processing';

      SelfcareAPI.takeInvoicePayment(payload)
        .then((response) => {
          if (response.status === true) {
            _this.paymentStatus = 'success';
            _this.getList();
          } else {
            _this.paymentStatus = 'failed';
          }
        }).catch((error) => {
          _this.paymentStatus = 'failed';
        }).finally(() => {
          // this block always execute
          // _this.paymentStatus = null;
        });

    },

    downloadInvoice(id) {
      let payload = {
        'invoice_id': id
      };

      SelfcareAPI.downloadInvoice(payload)
        .then((response) => {

          console.log("::::::Invoice Data:::::", response);
          const linkSource = `data:application/pdf;base64,${response.data}`;
          const downloadLink = document.createElement("a");
          const fileName = "invoice.pdf";
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();

        })
        .catch((error) => { })
        .finally(() => {
          // _this.list.is_loading = false;
        });

    },

    showDetails(id) {
      let item = this.list.find(o => o.id == id);
      console.log(":::::::Request Package Info:::::::", item);
      if (item.type === 'Subscription') {

        let itemDescriptions = JSON.parse(item.items);
        // console.log("Subscription items data", itemDescriptions);
        if (Array.isArray(itemDescriptions) && itemDescriptions.length > 0) {
          this.details = itemDescriptions.map(subscriptionItem => ({
            service_name: subscriptionItem.productName,
            service_charge: round(subscriptionItem.amount / 100, 2),
            invoice_at: item.invoice_at,
            status: item.status
          }));

        }
      } else {
        let remarks = JSON.parse(item.remarks);
        console.log("::::Remarks::::", remarks);
        if (remarks) {
          this.details = remarks.requestPackageInfos;
        }
        if (this.details && this.details.length > 0) {
          this.details = this.details.map(o => {
            o.invoice_at = item.invoice_at; //moment(item.invoice_at).format("MMM-YY");
            o.status = item.status;
            return o;
          });
        } else {
          let serviceName = remarks.packageInfos?.service_name;
          this.details = [
            {
              service_name: serviceName ?? item.type,
              service_charge: item.amount,
              invoice_at: item.invoice_at,
              status: item.status
            }
          ];
        }
      }


      console.log("::::Details::::", this.details);
      this.$nextTick(() => {
        $('#detailModal').modal('show');
      });

    },

    customFormatter(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },

    getFormattedDate(date) {
      return moment(date).format("MMM-YY");
    },

    formatNumber(value) {
      return parseFloat(value).toFixed(2);
    },

    getList() {
      let _this = this;
      _this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      query.cuid = subscriber ? subscriber.id : null;

      //  let unpaidInvoice = {
      //    "id": 1000,
      //    "type": "Fixed",
      //    "status": "Unpaid",
      //    "amount": "59.990000",
      //    "invoice_at": "2025-09-22 16:39:43",
      //    "account_id": "100450"
      //  };

      SelfcareAPI.getMyBillingHistory(query)
        .then((response) => {
          _this.list.is_loading = false;
          _this.list = response;
          //  _this.list.push(unpaidInvoice);
          _this.unpaidInvoice = _this.list.find(o => o.status === 'Unpaid' || o.status === 'Overdue'); // find first unpaid invoice from the list
          console.log("::::::Billing History:::::", response);
        })
        .catch((error) => { })
        .finally(() => {
          _this.list.is_loading = false;
        });
    },

    apiUsage(query = null) { },

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getList();
    },
  },
};
</script>
